import MarkingInfo from "./MarkingInfo";

export default MarkingInfo;
